export default "__VITE_ASSET__Cl3NOWyF__"